var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i18n',{attrs:{"path":_vm.value.event,"tag":"div"},scopedSlots:_vm._u([{key:"url",fn:function(){return [_c('a',{attrs:{"href":_vm.value.data.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.title))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }